import { render, staticRenderFns } from "./Football.vue?vue&type=template&id=34583c4b&scoped=true&"
import script from "./Football.vue?vue&type=script&lang=js&"
export * from "./Football.vue?vue&type=script&lang=js&"
import style0 from "./Football.vue?vue&type=style&index=0&id=34583c4b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34583c4b",
  null
  
)

export default component.exports